import { Component, OnInit } from '@angular/core';
import { MessageService } from '../../shared/errorHandler/message.service';
import { DocumentationTypeSetService } from '../../shared/services/documentation-type-set.service';
import { OrganizationalUnitService } from '../../shared/services/organizational-unit.service';
import { DocumentationTypeSet, DocumentationTypeSetFind } from '../../shared/models/documentationTypeSet.model';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';


@Component({
  standalone: false,
  selector: 'app-documentation-type-set-configuration-dialog',
  templateUrl: './documentation-type-set-configuration-dialog.component.html',
  styles: [
  ]
})
export class DocumentationTypeSetConfigurationDialogComponent implements OnInit {
  loading = false;
  currentStep = 'list';
  documentationTypeSets: DocumentationTypeSet[];
  selectDocumentationTypeSet: DocumentationTypeSet;
  addSetFormGroup: UntypedFormGroup;
  showDisabled = false;


  constructor(
    private messageService: MessageService,
    private documentationTypeSetSvc: DocumentationTypeSetService,
    private organizationalUnitService: OrganizationalUnitService,
    private _formBuilder: UntypedFormBuilder,
    private readonly transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.loadSets();


  }

  enabledStateIcon(dt): string{
    if (dt.enabled) return 'fa-check'
    else return 'fa-ban';
  }

  actionEnabledStateIcon(dt): string{
    if (!dt.enabled) return 'fa-check'
    else return 'fa-ban';
  }

  actionEnabledStateTitle(dt): string{
    if (!dt.enabled) return this.transloco.translate('candidates.newCandidateBtn.configureSetsBtn.activateSetBtn');
    else return this.transloco.translate('candidates.newCandidateBtn.configureSetsBtn.deactivateSetBtn');
  }

  changeEnabledState(dt){
    dt.enabled = !dt.enabled;
    firstValueFrom(this.documentationTypeSetSvc.modify(dt))
      .then(_data => {
        this.messageService.showInfo(this.transloco.translate('candidates.newCandidateBtn.configureSetsBtn.setStatusChangedLbl'));
        this.loadSets ();
      })
      .catch(err => this.messageService.showError(err));
    return;
  }
  changeShowDisabled() {
    this.showDisabled = !this.showDisabled;
    this.loadSets();
  }

  private loadSets() {
    this.loading = true;

    const findParameters: DocumentationTypeSetFind = {
      organizationalUnitId: this.organizationalUnitService.getCurrentOrChildOU().id,
      enabled: !this.showDisabled
      };
    firstValueFrom(this.documentationTypeSetSvc.get(findParameters))
      .then(data => {
        this.documentationTypeSets = data;
      })
      .catch(err => this.messageService.showError(err))
      .then(() => this.loading = false);
  }

  addSet() {
    this.addSetFormGroup = this._formBuilder.group({
      nameFrmCtrl: ['', Validators.required],
      descriptionFrmCtrl: [''],
    });

    this.currentStep = 'addForm';

  }

  openEdit(dt) {
    this.currentStep = 'editOpen';
    this.selectDocumentationTypeSet = dt;
  }

  createSet() {
    if (this.addSetFormGroup.invalid) {
      // this.messageService.showError('CPPAPIV001');
      return;
    }

    this.selectDocumentationTypeSet = {
      id: 0,
      name: this.addSetFormGroup.value.nameFrmCtrl,
      description: this.addSetFormGroup.value.descriptionFrmCtrl,
      documentationTypeSetItem: [],
      organizationalUnitId: this.organizationalUnitService.getCurrentOrChildOU().id,
      enabled: true,
      disabledDateTime: null,
      metricsSet:null
    };

    this.currentStep = 'editOpen';
  }

  closeEditSet() {
    this.currentStep = 'list';
    this.loadSets();
  }
}
